import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST } from "../../../services/api";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { mockUsers } from "../../../dummy/dummy";

const userSlice = createSlice({
    name: "users",
    initialState: {
        data: [],
        loading: false,
        error: null,

        currentUser: mockUsers[1],
    },
    reducers: {
        switchUser: (state, action) => {
            state.currentUser = action.payload;
        },
    },
    extraReducers: (builder) => {}
});

export const { switchUser } = userSlice.actions;

export default userSlice.reducer;